<template>
<div class="concierce_wrapper">
    <!-- header -->
    <div class="layer_header">
        <div class="header_inner">
            <div class="header_logo">
                <h1>
                    <a @click="closeBtn">Amway</a>
                </h1>
            </div>
            <button type="button" class="btn_layer_close" @click="closeBtn">닫기</button>
        </div>
    </div>
    
    <!-- contents-->
    <div class="contents">
        <div class="voucher_post_box">
            <div class="voucher_post">
                <img src="./images/concierce_voucher_mo.png" alt="DIAMOND DONCIERGE PHYTO CAFE 음료바우처">
            </div>
        </div>
        <!-- 임시 데이터 확인 필드-->
    <!-- <h1> {{this.tUserId}} :: {{this.tCouponSum}}</h1> -->
    
        <div class="voucher_info_box">
            <h2 class="title">
                파이토 카페 음료와 함께<br>
                건강한 웰니스 에너지 충전
            </h2>
            <div class="voucher_info_inner">
                <div class="voucher_info_sub">장소</div>
                <p class="voucher_info_txt">파이토 카페가 있는 전국 ABC/A STATION </p>
                <span>(분당/강서/인천/대전/울산/부산/창원/전주 ABC 및 A STATION) </span>
            </div>
            <div class="voucher_info_inner">
                <div class="voucher_info_sub">이용기한</div>
                <p class="voucher_info_txt">{{this.makeDateFormat(this.end_date)}}</p>
            </div>
            <div class="voucher_info_inner">
                <div class="voucher_info_sub">이용안내</div>
                <ul class="voucher_info_list">
                    <!-- S : 20221005 수정-->
                    <li>바우처 1장당 음료 한잔 (3,500원 가격) 선택이 가능합니다. (베이커리, 스낵 제외)</li>
                    <li>3,500원 이상 음료 선택 시, 추가 금액은 별도 결제 가능합니다. (3,500원 미만 음료는 차액 지불 미적용)</li>
                    <li>바우처는 현금으로 교환 및 잔액 환불이 불가합니다.</li>
                    <li>음료 선택 후, 파이토 카페 직원에게 바우처를 제시해 주시기 바랍니다.</li>
                    <!-- E : 20221005 수정-->
                </ul>
				<!-- S : 20221005 추가 -->
				<div class="voucher_info_inner">
					<div class="voucher_info_sub">유의사항</div>
					<ul class="voucher_info_list">
						<li>이용기한은 바우처 표기기한까지 입니다.</li>
						<li>이용기한 내 바우처 미사용 시, 분실 시 재발급 불가합니다.</li>
						<li>바우처가 포함된 메시지 삭제 시, 재발송 불가합니다.</li>
                        <li>바우처 선물 받으실 분의 휴대폰 번호를 정확히 입력해 주시기 바랍니다. 바우처 발송 후 회수 및 취소 불가합니다.</li>
						<li>양도/양수 가능합니다.</li>
					</ul>
				</div>
				<!-- E : 20221005 추가 -->
            </div>
        </div>

        			<div class="voucher_contact voucher_contact--evoucher">
				<p>사용하실 바우처의 총 수량을 선택해주세요.</p>

				<div class="evoucher_cnt">
					<dl>
						<dt>
							수량선택
							<p>(보유 : <span>{{this.tCouponSum}}</span>장)</p>
						</dt>
						<dd>
							<!-- Default: 보유 수량이 있는 경우 -> 감소 disabled -->
                            <!-- 보유수량 > 선택 수량 둘다 오픈 -->
                            <!-- 보유수량 = 선택 수량 -> 증가 disabled -->
							<div class="cnt_box">
								<input id="cp" class="ipt_input" type="number" :value="this.selectedCP" @change="calcCnt2()">								
                                <button type="button" class="btn_cnt btn_cnt_minus" @click="calcCnt('M')" v-bind:disabled="mBtnDisable">감소</button>
								<button type="button" class="btn_cnt btn_cnt_plus" @click="calcCnt('P')" v-bind:disabled="pBtnDisable">증가</button>
							</div>
						</dd>
					</dl>

					<dl>
						<dt>선택수량</dt>
						<dd>
							총 <span>{{this.selectedCP}}</span> 장
						</dd>
					</dl>
				</div>

				<div class="evoucher_num">
					<dl>
						<dt>잔여 바우처 수량</dt>
						<dd>
							총 <span>{{this.tCouponSum - this.selectedCP}}</span> 장
						</dd>
					</dl>
				</div>
			</div>

        <!-- S : 직원 확인 버튼 클릭 시 노출 -->
        <!-- <div class="voucher_contact" style="display: none;"> -->
        <div class="voucher_contact" v-show="exchange">
            <p>매장 선택 후, 직원 확인용 비밀번호를 입력해주세요.</p>
            <div class="contact_tel">
                <div class="contact_tel_1">
                    <select class="form-tel" title="ABC 지역 입력" @change="selectBoxChange($event)">
                        <option :key="i" :value="storeInfo.store_code" v-for="(storeInfo,i) in storeInfo">{{ storeInfo.store_name }} ABC</option>
                    </select>
                </div>
                <div class="contact_tel_2">
                    <input v-model="store_pw" type="password" class="form-tel" placeholder="****" title="비밀번호 입력">
                </div>
            </div>
        </div>
        <!-- E : 직원 확인 버튼 클릭 시 노출 -->

        <div class="concierce_btn_area">
            <!-- 바우처 교환 전 직원확인 비밀번호 입력영역 열기 버튼 활성화 case -->
            <button v-show="confirm" type="button" class="btn-pop-submit" v-on:click="confirmEMP()">직원 확인</button>
            
            <!-- 바우처 교환 전 case-->
            <button type="button" class="btn-pop-submit"  v-show="exchange" v-on:click="exchangeCoupon()">바우처 교환 완료 처리</button>
            <!-- 바우처 교환 완료 case -->
            <button type="button" class="btn-pop-submit" v-show="exchangeSuccess" v-bind:disabled="exchangeSuccess">교환 완료</button>
            <!-- 바우처 사용 기한 만료 case -->
            <button type="button" class="btn-pop-submit" v-show="expired" disabled  style="display:none">사용 기한 만료</button>
        </div>
    </div>
</div>
</template>


   
<script>

// Library
import Vue from 'vue'
import axios from 'axios'
import querystring from 'querystring'
import $ from 'jquery'
import { async } from 'q'

export default {
    metaInfo: {
    title: '다이아몬드 컨시어지 파이토 카페 바우처 선물하기',
    meta: [
        { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge,chrome=1' },
        { charset:'utf-8' },
        { name:'viewport', content:'width=device-width, initial-scale=1' },
        { name:'keywords'},
        { name:'description', content:'NY Fee Bundle'},
        { name:'robots', content:'index,follow'},
        { property:'og:description', content:'한웨이님이 선물하신 ABC 파이토 카페 음료 바우처를 사용해 보세요.'},
        { property:'og:image', content:'./images/concierce_kakao_thumb.png'}
    ]
    },
    name: 'myCouponDTL',
    components: {

        
    },
    props:{
        targetUserId: Number,
        total_coupon_sum : Number
    },
    data () {
        return {
            isConfirm : true,
            isExchanged : false,
            isExchangeSuccess : false,
            isExpired : false,
            ready: false,
            storeInfo : [{id: '', store_code: '', store_name: '', pin_num: '', modified_by: '', modified_date: '', created_by: '', created_date: ''}],
            end_date : '',
            store_pw : '',
            aboInfo: Object,
            tUserId: Number,
            tCouponSum: Number,
            inProgress : false,
            selectedCP : 1,
            mBtnDisabled : true,
            pBtnDisabled : false,
            rechangeCouponSum : null
        }
    },
    computed:{
        confirm(){
           return this.isConfirm 
        },
        exchange(){
            return this.isExchanged
        },
        exchangeSuccess(){
            return this.isExchangeSuccess
        },
        expired(){
            return this.isExpired   
        },
        mBtnDisable(){
            return this.mBtnDisabled
        },
        pBtnDisable(){
            return this.pBtnDisabled
        }
    },
    methods: {
        init: async function () { // 초기화
            this.aboInfo = {aboNo: '', aboName: '', aboPhone: '', pinLevel: ''},
            await this.checkLogin() // 로그인 체크(회원번호,이름)
            this.tUserId = this.targetUserId;
            this.tCouponSum = this.total_coupon_sum;
            this.useCnt = 0;

            if(this.tUserId != undefined){               
                sessionStorage.setItem('targetUserId',this.tUserId)
            }
            this.tUserId = sessionStorage.getItem('targetUserId')

            if(this.tCouponSum != undefined){               
                sessionStorage.setItem('total_coupon_sum',this.tCouponSum)
            }
            this.tCouponSum = sessionStorage.getItem('total_coupon_sum')

            // storeInfo
            this.storeInfo = [{id: '', store_code: '', store_name: '', pin_num: '', modified_by: '', modified_date: '', created_by: '', created_date: ''}]
            await this.getStoreInfo()


            // button visibility
            this.isConfirm = true
            this.isExchanged = false
            this.isExchangeSuccess = false
            this.isExpired = false
            this.nowdate = ''
            
            // param
            //this.end_date_2 = '2022-08-18 10:35:44'
            if(this.endDate == null){
                this.endDate = '0000-01-01 12:00:00'
            }            
            this.end_date = this.endDate.substring(0, 10)
            this.cpyear = this.endDate.substring(0,4)
            this.cpmonth = this.endDate.substring(5,7)
            this.cpdate = this.endDate.substring(8,10)
            

            // 연도, 월, 일 추출
            const js_date = new Date();
            const cpdate = new Date(this.cpyear, this.cpmonth-1, this.cpdate)
            const nowdate = new Date(js_date.getFullYear(),js_date.getMonth(),js_date.getDate());

            // 유효기간 만료시 버튼 처리
            if(cpdate >= nowdate){
                this.isExpired = false
            }else{
                this.isExpired = true
                this.isConfirm = false
                this.isExchanged = false
                this.isExchangeSuccess = false
            }
            
            // 받아야 할 parameter
            // target_user_id, abo_name, end_date

            // 사용처리시 필요한 param
            // sent_coupont_id(gift), target_user_id(my), store_code, pin_num,gift (my or gift)
        },
        makeDateFormat:function(tDate){
            if(tDate){
                const dt = new Date(tDate);
                return dt.getFullYear()+"년 "+(dt.getMonth()+1)+"월 "+dt.getDate()+"일 까지";
            }
        }, 
        checkLogin: async function () {
        await axios.get(process.env.OCC_ROOT_URL + '/sso/authorizeEvent', {withCredentials: true}
        ).then(response => {
            if (response.data.header.status === 'ERROR') { // login fail
                window.location.href = process.env.AMWAY_ROOT_URL + '/login'
            } else if (response.data.customerUid != null && response.data.customerUid !== 'none') {
                // login success
                this.aboInfo.aboNo = atob(response.data.customerUid)
                this.aboInfo.aboName = response.data.name
            }
        }).catch(ex => {
            alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
            window.location.href = process.env.AMWAY_ROOT_URL + '/login'
        })
        },
        closeBtn: function(){
			this.$router.go(-1);
		},
        confirmEMP: function () {
            if (this.isConfirm == true){
                this.isConfirm = false
                this.isExchanged = true
            }else {
                this.isConfirm = true
            }
            
            setTimeout(function () {
                $(".concierce_wrapper")[0].scrollIntoView({behavior : "smooth", block : "end", inline: "end"})
                }, 100
            )
        },
        selectBoxChange: function(event){
            this.store_code = event.target.value
        },
        exchangeCoupon: async function(cnt){
            cnt = this.selectedCP // 추후 삭제
            if(this.inProgress === false){
                this.inProgress = true
                if(this.store_pw == ''){
                    alert('비밀번호를 입력하여 주십시오.')                    
                }else{                    
                    await axios.post(process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-useCoupon', {            
                        scid:'',
                        tuid: this.tUserId,
                        store_cd : this.store_code,
                        pin_num : this.store_pw,
                        gift:'my',
                        useCnt: cnt,
                        created_by : 'SYSTEM',
                        modified_by : 'SYSTEM'
                    }, {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                    }).then(response => {
                    // console.log('response : ', JSON.stringify(response, null, 2))            
                    if (response.data.statusCode === 200) {
                                        
                        this.confirmResult = JSON.parse(response.data.results)
                        // console.log(this.confirmResult[0].resultCode)
                        if(this.confirmResult[0].resultCode === "PIN FAULT"){
                            alert('비밀번호를 다시 확인해주세요.')
                        }else if(this.confirmResult[0].resultCode === "STORE INVALID"){
                            alert('store Invalide')
                        }else if(this.confirmResult[0].resultCode === "COUPON Not Enough" || this.confirmResult[0].resultCode === "COUPON 0" ){
                            alert('쿠폰 보유수량이 부족합니다.')
                            console.log(this.confirmResult[0].resultCode)
                            this.adjustGetCoupon()
                        }else if(this.confirmResult[0].resultCode ==="SUCCESS"){
                            alert('교환 완료')
                            
                            // ABC Select box, 쿠푼교환 완료처리 버튼 숨김
                            this.isExchanged = false
                            // 교환완료 버튼 노출 및 disabled 처리
                            this.isExchangeSuccess = true

                            // 메인페이지로 이동 
                            this.$router.go(-1);

                        }else if(this.confirmResult[0].resultCode ==="COUPON EXPIRED"){
                            alert('유효기간이 만료 되었습니다.')                        
                            this.$router.go(0);
                        }
                    } else {
                        alert('500')
                    }
                    }).catch(error => {
                        console.log('error : ', error)
                        alert('잠시후 다시 시도 부탁드립니다.')
                    })
                }
            }
            this.inProgress = false       
        },
        // store정보
        getStoreInfo: async function () {
            await axios.post(process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-myCoupon', {
                'scid' : '',
                'tuid' : this.tUserId
            }, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
            }).then(response => {
            // console.log('response : ', JSON.stringify(response, null, 2))            
            if (response.data.statusCode === 200) {
                this.storeInfo = JSON.parse(response.data.storeList)
                if(this.storeInfo.length > 0){
                    this.store_code = this.storeInfo[0].store_code                
                }
                this.endDate = JSON.parse(response.data.end_date)[0].end_date                
            } else {
                alert('Fail to load store info')
            }
            }).catch(error => {
                console.log('error : ', error)
                alert('잠시후 다시 시도 부탁드립니다.')
            })
        },

        // 수량 버튼 계산
        calcCnt: function(flag){
            if (flag == 'M'){
                this.selectedCP --
            }else if (flag == 'P'){
                this.selectedCP ++
            }
            if(this.selectedCP > 1 && this.selectedCP < this.tCouponSum){
                this.mBtnDisabled = false
                this.pBtnDisabled = false
            }
            if(this.selectedCP >= this.tCouponSum){
                this.pBtnDisabled = true
            }
            if (this.selectedCP <= 1){
                this.mBtnDisabled = true
            }      
            // console.log(this.selectedCP +"  "+ this.tCouponSum)
        },

        // 수량 입력 계산
        calcCnt2: function(){            
            var cp = $("#cp").val()
            this.selectedCP = Number(cp)
            
            if(this.selectedCP > 1 && this.selectedCP < this.tCouponSum){
                this.mBtnDisabled = false
                this.pBtnDisabled = false
            }
            if(this.selectedCP >= this.tCouponSum){                
                this.pBtnDisabled = true
                this.mBtnDisabled = false
                this.selectedCP = this.tCouponSum
            }
            if (this.selectedCP <= 1){
                this.mBtnDisabled = true
                this.pBtnDisabled = false
                this.selectedCP = 1
            }
            // console.log(this.selectedCP +"  "+ this.tCouponSum)
        },
        // 쿠폰보유 부족 시 데이터 재조회 
        async adjustGetCoupon() {
            await axios.post(process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-login-info',{
                abo_no : this.aboInfo.aboNo
            }).then(response =>{
                console.log("[Target ID]" , this.targetUserId)
                let couponTargetId = JSON.parse(response.data.results)
                console.log(couponTargetId[1])
                console.log(this.tCouponSum)
                // 보유수량이 없을때 사용하려는 경우 뒤로가기.
                for(let i=0; i<couponTargetId.length; i ++) {
                    if (this.targetUserId === couponTargetId[i].id) {
                        if (couponTargetId[i].total_coupon_sum <= 0) {
                            // this.rechangeCouponSum = couponTargetId[i]
                            // this.tCouponSum = this.rechangeCouponSum.total_coupon_sum
                            // this.selectedCP = 0
                            this.$router.go(-1)
                        }else {
                            this.rechangeCouponSum = couponTargetId[i]
                            this.tCouponSum = this.rechangeCouponSum.total_coupon_sum
                            this.selectedCP = 1
                        }
                    }
                }
            })
            .catch(error =>{
                console.log('error : ', error)
            })
        }
    },
    mounted() {
        window.setTimeout(() => {
            this.ready = true
            this.init()
            }, 500)
        window.scrollTo(0, 0)
    },
    created() {}
}
</script>

<style>
    @import './css/concierce.css';
</style>



// WEBPACK FOOTER //
// src/views/concierge/myCouponDTL.vue